import Swiper                                       from 'swiper';
import { Autoplay, Navigation, Pagination, Thumbs } from 'swiper/modules';
import { arrayFrom, findElem, findElems }           from "@ts/utils/helpers.js";

/**
 * Swiper initialization module
 */
export default () : void => {

    /*const stepsOneSwiper = (): void => {
     const swiper_element: HTMLElement | null = findElem('.steps-1__swiper');
     if (!swiper_element) return;

     const my_swiper: Swiper = new Swiper(swiper_element, {
     modules: [Autoplay],
     slidesPerView: 'auto',
     spaceBetween: 16,
     speed: 1000,
     lazyPreloadPrevNext: true,
     autoplay: {
     delay: 1500,
     pauseOnMouseEnter: true,
     disableOnInteraction: false,
     },
     breakpoints: {
     992: {
     slidesPerView: 3,
     },
     1024: {
     loop: false,
     autoplay: false,
     slidesPerView: 4,
     spaceBetween: 25,
     }
     }
     });

     (swiper_element as HTMLElement).addEventListener('touchstart', (): void => {
     my_swiper.autoplay.stop();
     });
     };
     stepsOneSwiper();*/

    /*const reviews = (): void => {
     const swiper_element: HTMLElement | null = findElem('.reviews__swiper');
     if (!swiper_element) return;

     new Swiper(swiper_element, {
     modules: [Navigation, Pagination],
     loop: true,
     slidesPerView: 'auto',
     spaceBetween: 16,
     speed: 800,
     navigation: {
     prevEl: '.reviews__navigation._prev',
     nextEl: '.reviews__navigation._next',
     disabledClass: '_disabled',
     lockClass: '_lock',
     },
     pagination: {
     el: '.reviews__pagination',
     type: 'bullets',
     bulletClass: 'bullet',
     bulletActiveClass: '_act',
     clickable: true,
     },
     breakpoints: {
     992: {
     slidesPerView: 3,
     },
     1200: {
     slidesPerView: 4,
     spaceBetween: 25,
     }
     }
     });
     };
     reviews();*/

    const products = () : void => {
        const element : HTMLElement | null = findElem('.products__swiper');
        if (!element) return;

        let is_init : boolean = false;
        let swiper : Swiper;

        const init = () : void => {
            if (is_init) return;

            swiper = new Swiper(element, {
                modules:       [Navigation],
                slidesPerView: 'auto',
                spaceBetween:  16,
                speed:         800,
                navigation:    {
                    prevEl:        findElem('.products__navigation._prev'),
                    nextEl:        findElem('.products__navigation._next'),
                    disabledClass: '_disabled',
                    lockClass:     '_lock'
                },
                breakpoints:   {
                    1200: {
                        spaceBetween: 24,
                    }
                },
                on:            {
                    init: () : void => {
                        is_init = true;
                    }
                }
            });
        };

        init();

        window.addEventListener('resize', init);
    };

    products();

    const productsGallery = () : void => {
        const swipers : HTMLElement[] | [] = arrayFrom(findElems('.products-gallery'));
        if (!swipers?.length) return;

        swipers.forEach((swiper_element : HTMLElement) : void => {
            new Swiper(swiper_element, {
                modules:       [Navigation, Pagination],
                loop:          true,
                slidesPerView: 1,
                spaceBetween:  0,
                speed:         800,
                navigation:    {
                    prevEl:        findElem('.products-gallery__navigation._prev', swiper_element),
                    nextEl:        findElem('.products-gallery__navigation._next', swiper_element),
                    disabledClass: '_disabled',
                    lockClass:     '_lock',
                },
                pagination:    {
                    el:                findElem('.products-gallery__pagination', swiper_element),
                    type:              'bullets',
                    bulletClass:       'bullet',
                    bulletActiveClass: '_act',
                    clickable:         true,
                },
            });
        });
    };

    productsGallery();

    const getProductPageGalleryThumbs = () : Swiper | undefined => {
        const thumbs : HTMLElement | null = findElem('.product-top__pagination--thumbs');

        if (!thumbs) {
            return;
        }

        return new Swiper(thumbs, {
            spaceBetween:        8,
            slidesPerView:       4,
            freeMode:            true,
            watchSlidesProgress: true,
        });
    };

    const productPageGallery = () : void => {
        const swipers : HTMLElement[] | [] = arrayFrom(findElems('.products-top__swiper'));

        if (!swipers?.length) {
            return;
        }

        swipers.forEach((swiper_element : HTMLElement) : void => {
            const swiper_instance : Swiper = new Swiper(swiper_element, {
                modules:             [Autoplay, Navigation, Thumbs],
                loop:                false,
                slidesPerView:       1,
                spaceBetween:        10,
                speed:               800,
                lazyPreloadPrevNext: 1,
                autoplay:            {
                    // @ts-ignore
                    enabled:              false,
                    delay:                5000,
                    pauseOnMouseEnter:    true,
                    disableOnInteraction: false,
                },
                navigation:          {
                    prevEl:        findElem('.product-top__navigation._prev'),
                    nextEl:        findElem('.product-top__navigation._next'),
                    disabledClass: '_disabled',
                    lockClass:     '_lock',
                },
                thumbs:              {
                    swiper: getProductPageGalleryThumbs(),
                },
            });

            (swiper_element as HTMLElement).addEventListener('touchstart', () : void => {
                swiper_instance.autoplay.stop();
            });
        });
    };

    productPageGallery();
};